import { createSelector } from 'reselect'

import { uniqueBy } from 'clickNgo/helpers/array'

import { selectCockpitPartnerData } from './selectCockpitPartnerData'
import { selectCockpitRtm } from './selectCockpitRtm'

export const selectCockpitGlobalPartnerOptions = createSelector(
  [selectCockpitPartnerData, selectCockpitRtm],
  (partnerData, selectedRtm) =>
    uniqueBy(
      partnerData
        .filter((partner) =>
          selectedRtm === 'resellers' ? partner.IsCommercial === 1 : partner.IsDistributor === 1
        )
        .filter((partner): partner is typeof partner & { GlobalPartnerId: string } =>
          Boolean(partner.GlobalPartnerId)
        )
        .map((partner) => ({
          GlobalPartnerId: partner.GlobalPartnerId,
          GlobalPartnerName: partner.GlobalPartnerName || partner.GlobalPartnerId,
        })),
      (option) => option.GlobalPartnerId
    )
)
